import React, { useEffect, useState, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Header from "../../PublicOrdering/pages/Header";
import NumberWithCommas from "../../../pages/Pages/Starter/NumberWithCommas";
import playBeep from "./PlayBeep";
import ThemeFooter from "../../QRMenu/component/ThemeFooter";
import TouchBasedHeader from "../TourchBased/TouchBasedHeader";
import PublicOrderingLayout from "../../QRMenu/Theme2/PublicOrderingLayout";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, FreeMode } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import ads from "../../../assets/ads/ads.jpeg";
import ads1 from "../../../assets/ads/ads1.jpeg";
import ads2 from "../../../assets/ads/ads2.jpeg";
import PublicOrderingServices from "../services/PublicOrderingServices";
import { clearCart } from "../../../slices/cart/publicOrderingCartSlice";
import AdService from "../../../services/AdService/AdService";
import AdLogService from "../../../services/AdService/AdLogService";

const OrderSummary = () => {
  const location = useLocation();
  const {
    orgData,
    orderResponse,
    orderPost,
    phoneNumber,
    orderPayload,
    isPending,
    cart: cartFromState,
  } = location.state || {};
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { orgcode } = useParams();
  const [isLoading, setIsLoading] = useState(false);

  const appType = window?.APP_CONFIG?.appType;
  const isTouchBased = appType === "TouchBased";

  const cart = useSelector((state) => state.publicOrderingCart);
  const [savedOrder, setSavedOrder] = useState(null);
  const customerInfo = JSON.parse(localStorage.getItem("CustomerInfo"));

  const [isTouchBasedSetting, setIsTouchBasedSetting] = useState(() => {
    const stored = localStorage.getItem("isTouchBasedSetting");
    return stored !== null ? JSON.parse(stored) : true;
  });
  const [showPayloadPreview, setShowPayloadPreview] = useState(false);
  const [payloadData, setPayloadData] = useState(null);
  const [isPrinting, setIsPrinting] = useState(false);
  const [printMessage, setPrintMessage] = useState("");

  // Ad system state
  const [ads, setAds] = useState([]);
  const [deviceInfo, setDeviceInfo] = useState(null);
  const adsFetchedRef = useRef(false);
  const swiperRef = useRef(null);
  const slideTimerRef = useRef(null);

  // Use cart from state if pending, otherwise use orderResponse/orderPost
  const orderDetails = isPending
    ? cartFromState || []
    : orderResponse?.items || orderPost?.orderDetails || [];

  const orderData = {
    orderId: orderResponse?.orderId || orderPost?.orderRefrenceId || "N/A",
    placedTime: orderResponse?.orderDate || orderPost?.orderDate || "N/A",
    customer: customerInfo?.customer?.name || {
      name: phoneNumber ? `Phone Customer (${phoneNumber})` : "Guest",
      phoneNumber: phoneNumber || "N/A",
    },
    items: orderDetails.map((item) => {
      // Extract unit price
      const unitPrice = isPending
        ? item.basePrice || item.price || item.productPrice || 0
        : item.productPrice || item.price || 0;

      // Extract quantity
      const quantity = item.qty || item.quantity || 0;

      // Calculate total for this item
      const itemTotal = unitPrice * quantity;

      return {
        uid: item.id || item.uid,
        name: item.name || item.productName,
        qty: quantity,
        productPrice: unitPrice,
        totalPrice: itemTotal,
        addons: item.addons || item.children,
        attributes: item.attributes,
        note: item.note,
        total: itemTotal,
      };
    }),
    total: orderDetails.reduce((sum, item) => {
      const unitPrice = isPending
        ? item.basePrice || item.price || item.productPrice || 0
        : item.productPrice || item.price || 0;
      const quantity = item.qty || item.quantity || 0;
      return sum + unitPrice * quantity;
    }, 0),
    orgCode: orgcode,
  };

  const handleProceedToCheckout = async () => {
    setIsLoading(true);
    try {
      const pendingOrderData = JSON.parse(localStorage.getItem("pendingOrder"));

      if (!pendingOrderData) {
        alert("Order data not found. Please try again.");
        setIsLoading(false);
        return;
      }

      const { orderPayload: savedOrderPayload, isLoggedIn } = pendingOrderData;

      // 📊 Prepare payload and submit directly
      const fullPayload = {
        token: isLoggedIn ? customerInfo?.accessToken : null,
        apikey: orgcode,
        orderPayload: savedOrderPayload,
        phoneNumber: isTouchBased ? "9808827451" : null,
      };

      console.log(
        "🚀 ~ handleProceedToCheckout ~ FULL PAYLOAD TO BE SENT:",
        fullPayload,
      );
      console.log(
        "📋 Order Payload Details:",
        JSON.stringify(fullPayload, null, 2),
      );

      // Submit order directly
      const response = await PublicOrderingServices.orderOnline({
        token: fullPayload.token,
        apikey: fullPayload.apikey,
        orderPayload: fullPayload.orderPayload,
        phoneNumber: fullPayload.phoneNumber,
      });

      console.log("🚀 ~ handleProceedToCheckout ~ response:", response);
      console.log("✅ ORDER SUCCESS:", response);

      // Clear localStorage and cart
      localStorage.removeItem("publicCartV2");
      localStorage.removeItem("pendingOrder");
      dispatch(clearCart());

      // Navigate to checkout with response data
      navigate(`/${orgcode}/customer-checkout`, {
        state: {
          orgData,
          orderResponse: response,
        },
      });
    } catch (error) {
      console.error("❌ ORDER FAILED:", error);
      alert(error?.message || "Failed to place order");
      setIsLoading(false);
    }
  };

  // Confirm and actually submit the order
  const handleConfirmAndSubmit = async () => {
    try {
      setIsLoading(true);

      const response = await PublicOrderingServices.orderOnline({
        token: payloadData.token,
        apikey: payloadData.apikey,
        orderPayload: payloadData.orderPayload,
        phoneNumber: payloadData.phoneNumber,
      });

      console.log("🚀 ~ handleConfirmAndSubmit ~ response:", response);
      console.log("✅ ORDER SUCCESS:", response);

      // Clear localStorage and cart
      localStorage.removeItem("publicCartV2");
      localStorage.removeItem("pendingOrder");
      dispatch(clearCart());

      // Close payload preview
      setShowPayloadPreview(false);

      // Navigate to checkout with response data
      navigate(`/${orgcode}/customer-checkout`, {
        state: {
          orgData,
          orderResponse: response,
        },
      });
    } catch (error) {
      console.error("❌ ORDER FAILED:", error);
      alert(error?.message || "Failed to place order");
    } finally {
      setIsLoading(false);
    }
  };

  // 🎹 Keyboard shortcut for testing modal (Ctrl+Shift+P)
  useEffect(() => {
    const handleKeyPress = (e) => {
      // Ctrl+Shift+P to open testing modal
      if (e.ctrlKey && e.shiftKey && e.key === 'P') {
        e.preventDefault();
        console.log('🔑 Testing modal shortcut activated!');
        
        // Prepare the payload and show modal
        const pendingOrderData = JSON.parse(localStorage.getItem("pendingOrder"));
        if (pendingOrderData) {
          const { orderPayload: savedOrderPayload, isLoggedIn } = pendingOrderData;
          const fullPayload = {
            token: isLoggedIn ? customerInfo?.accessToken : null,
            apikey: orgcode,
            orderPayload: savedOrderPayload,
            phoneNumber: isTouchBased ? "9808827451" : null,
          };
          setPayloadData(fullPayload);
          setShowPayloadPreview(true);
        }
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [customerInfo, orgcode, isTouchBased]);

  // 🖨️ Manual print function for testing
  // Get device info from localStorage (set by modalinspect.jsx)
  useEffect(() => {
    try {
      const deviceContext = localStorage.getItem("deviceContext");
      const macId = localStorage.getItem("macId");
      const ipAddress = localStorage.getItem("ipAddress") || "0.0.0.0";

      if (deviceContext) {
        const context = JSON.parse(deviceContext);
        setDeviceInfo({
          macId: macId,
          deviceName: context.deviceName || "Unknown Device",
          ipAddress: ipAddress,
          deviceCode: context.deviceCode,
          orgCode: context.orgCode,
          terminal: context.terminal || "T1",
        });
      }
    } catch (error) {
      console.error("Error reading device info:", error);
    }
  }, []);

  // Log ad impression when banner is displayed
  const logAdImpression = async (ad, visibleSeconds = 5) => {
    if (!deviceInfo) return; // Skip if no device info

    try {
      const now = new Date();
      const shownTime = now.toISOString();
      const hiddenTime = new Date(
        now.getTime() + visibleSeconds * 1000,
      ).toISOString();

      const adLog = {
        adId: ad.id,
        macId: deviceInfo.macId,
        deviceName: deviceInfo.deviceName,
        ipAddress: deviceInfo.ipAddress,
        shownAt: shownTime,
        hiddenAt: hiddenTime,
        visibleSeconds: visibleSeconds,
        playedSeconds: visibleSeconds,
        wasCompleted: true,
        wasSkipped: false,
        displayReason: 1, // Banner display
        screenName: "Banner",
        appVersion: "v1",
      };
      console.log("🚀 ~ logAdImpression ~ adLog:", adLog);

      await AdLogService.logAdImpression(adLog);
      console.log("✅ Ad impression logged:", ad.id);
    } catch (error) {
      console.error("❌ Error logging ad impression:", error);
    }
  };

  // Fetch ads on component mount and set up polling
  useEffect(() => {
    // Skip if already fetched or no device info
    if (adsFetchedRef.current || !deviceInfo) {
      if (!deviceInfo) {
        console.log("⏭️ ~ Device info not available yet, skipping ad fetch");
      } else {
        console.log("⏭️ ~ Ads already fetched, skipping");
      }
      return;
    }

    const fetchAds = async () => {
      try {
        // Fetch ads by MAC address using the new API
        const data = await AdLogService.getAdsByMacAddress(deviceInfo.macId);
        console.log("🚀 ~ fetchAds ~ data from MAC:", data);

        // Keep all ad types and let consumers decide how to render each type
        const baseApi =
          window.APP_CONFIG?.api4?.baseapi ||
          "https://api-databasewebservice.danfesolution.com";
        const resolveMediaUrl = (path) => {
          if (!path) return "";
          if (/^https?:\/\//i.test(path)) return path;
          if (path.startsWith("/")) return `${baseApi}${path}`;
          return `${baseApi}/${path}`;
        };
        const normalizedAds = (Array.isArray(data) ? data : [])
          .sort((a, b) => a.priority - b.priority)
          .map((ad) => ({
            id: ad.id,
            title: ad.title,
            description: ad.description,
            mediaType: Number(ad.mediaType),
            mediaPath: resolveMediaUrl(ad.mediaPath),
            thumbnailPath: resolveMediaUrl(ad.thumbnailPath),
            priority: ad.priority ?? 999,
            durationSeconds: ad.durationSeconds || 10,
            videoLengthSeconds: ad.videoLengthSeconds || 0,
          }));

        console.log("🚀 ~ fetchAds ~ normalizedAds:", normalizedAds);
        setAds(normalizedAds);
      } catch (error) {
        console.error("Error fetching ads by MAC address:", error);
      }
    };

    // Fetch ads immediately on component mount
    adsFetchedRef.current = true;
    fetchAds();

    // Set up polling to refresh ads every 30 seconds for smooth updates
    const adRefreshInterval = setInterval(fetchAds, 30000);

    // Cleanup interval on component unmount
    return () => clearInterval(adRefreshInterval);
  }, [deviceInfo]);

  // Cleanup timer on component unmount
  useEffect(() => {
    return () => {
      if (slideTimerRef.current) {
        clearTimeout(slideTimerRef.current);
      }
    };
  }, []);

  // Compute imageAds before all hooks
  const imageAds = ads.filter((ad) => Number(ad.mediaType) === 1);

  // SLIDESHOW EFFECT - Run slideshow with image ads
  useEffect(() => {
    if (!deviceInfo || imageAds.length === 0) {
      // Clear timer if no ads or device info
      if (slideTimerRef.current) {
        clearTimeout(slideTimerRef.current);
      }
      return;
    }

    // Clear previous timer
    if (slideTimerRef.current) {
      clearTimeout(slideTimerRef.current);
    }

    // ----------- CASE 1: Only One Ad -----------
    if (imageAds.length === 1) {
      const singleAd = imageAds[0];
      const duration = singleAd.durationSeconds || 5;

      const runSingleAdLoop = () => {
        logAdImpression(singleAd, duration);

        slideTimerRef.current = setTimeout(() => {
          runSingleAdLoop(); // loop again
        }, duration * 1000);
      };

      runSingleAdLoop();
      return;
    }

    // ----------- CASE 2: Multiple Ads -----------
    if (swiperRef.current) {
      swiperRef.current?.swiper?.slideToLoop(0); // reset to first slide
    }

    const startSlideShow = (index = 0) => {
      const currentAd = imageAds[index];
      if (!currentAd) return;

      const duration = currentAd.durationSeconds || 5;

      logAdImpression(currentAd, duration);

      slideTimerRef.current = setTimeout(() => {
        if (!swiperRef.current?.swiper) return;

        swiperRef.current.swiper.slideNext();

        const nextIndex = (index + 1) % imageAds.length;

        startSlideShow(nextIndex);
      }, duration * 1000);
    };

    startSlideShow(0);

    return () => {
      if (slideTimerRef.current) {
        clearTimeout(slideTimerRef.current);
      }
    };
  }, [imageAds, deviceInfo]);

  const handleManualPrint = async () => {
    try {
      if (!window.chrome?.webview) {
        setPrintMessage(
          "❌ WebView2 bridge not available - not running in WPF",
        );
        setTimeout(() => setPrintMessage(""), 3000);
        return;
      }

      setIsPrinting(true);
      setPrintMessage("🖨️ Preparing bill for printing...");

      // Construct bill items from orderData
      const billItems = orderData.items.map((item) => ({
        ItemName: item.name,
        Quantity: item.qty,
        UnitPrice: item.productPrice,
        TotalPrice: item.total,
      }));

      const printPayload = {
        Type: "PRINT_BILL",
        ApiKey: orgcode, // Use orgCode as API key for printer config
        Bill: {
          CafeName:
            orgData?.organizationName || orgData?.orgName || "Restaurant",
          Location: orgData?.address || orgData?.location || "",
          Phone: orgData?.phone || "",
          Pan: orgData?.pan || "",

          SalesInvoiceNumber: orderData.orderId || "INV-001",
          RefSalesInvoiceNumber: "",
          ReturnInvoiceNumber: "",
          IsEstimatePrint: false,
          BillRemarks: "",
          TableName: "Online Order",

          CustomerName: customerInfo?.user?.username || "Guest",
          CustomerPhone: customerInfo?.user?.phoneNumber || "",
          CustomerAddress: "",
          CustomerPan: "",

          SubTotal: orderData.total,
          Discount: 0,
          VAT: 0,
          ServiceCharge: 0,
          NetAmount: orderData.total,
          PaymentTypes: ["Online"],

          BillPrintedBy: "System",
          Message: "Thank you for your order!",

          Items: billItems,
        },
      };

      setPrintMessage("📤 Sending bill to WPF printer...");
      console.log("🖨️ Print Payload:", printPayload);

      // Send to WPF app
      window.chrome.webview.postMessage(printPayload);

      setPrintMessage("✅ Print request sent successfully!");
      setTimeout(() => {
        setPrintMessage("");
        setIsPrinting(false);
      }, 2000);
    } catch (error) {
      console.error("Print error:", error);
      setPrintMessage(`❌ Print error: ${error.message}`);
      setIsPrinting(false);
      setTimeout(() => setPrintMessage(""), 3000);
    }
  };

  if (!orderData) {
    return (
      <Container className="py-3 py-md-4">
        <Card>
          <CardBody className="text-center py-4">
            <h5 className="mb-3" style={{ fontSize: "1rem" }}>
              No order found
            </h5>
            <p style={{ fontSize: "0.875rem", color: "#6c757d" }}>
              Your cart is empty and no recent order exists.
            </p>
            <Button
              color="primary"
              size="sm"
              onClick={() => {
                playBeep();
                navigate(`/${orgcode}`);
              }}
            >
              Go Back
            </Button>
          </CardBody>
        </Card>
      </Container>
    );
  }

  return (
    <>
      <PublicOrderingLayout
        orgData={orgData}
        orgcode={orgcode}
        isTouchBasedSetting={isTouchBasedSetting}
        setIsTouchBasedSetting={setIsTouchBasedSetting}
        deviceInfo={{
          macId: localStorage.getItem("macId"),
          deviceName:
            JSON.parse(localStorage.getItem("deviceContext") || "{}")
              .deviceName || "Unknown",
          ipAddress: localStorage.getItem("ipAddress") || "0.0.0.0",
        }}
        ads={ads}
      >
        <Row className="">
          <Col
            xs={12}
            lg={{ size: 10, offset: 1 }}
            xl={{ size: 10, offset: 1 }}
          >
            {/* Page Title */}
            <div className="d-flex align-items-center justify-content-between mb-3">
              <h3
                className="fw-bold mb-0"
                style={{
                  fontSize: "1.7rem",
                  color: "#212529",
                }}
              >
                Order Summary
              </h3>
              <Button
                // color="secondary"
                size="sm"
                onClick={() => {
                  playBeep();
                  navigate(`/${orgcode}`, { replace: true });
                }}
                style={{
                  padding: "6px 16px",
                  fontSize: "0.85rem",
                  fontWeight: "600",
                  borderRadius: "6px",
                  backgroundColor: "#f85606",
                }}
              >
                <i
                  className="bx bx-arrow-back me-2"
                  style={{ fontSize: "16px" }}
                />
                Back to Menu
              </Button>
            </div>

            {/* Items Card */}
            <Card className=" mb-3">
              <CardBody>
                {/* Section Header */}
                <div className="d-flex align-items-center justify-content-between ">
                  <div
                    className="d-flex align-items-center justify-content-center gap-2"
                    style={{ gap: "6px" }}
                  >
                    <h5 className="fw-bold" style={{ fontSize: "0.95rem" }}>
                      Ordered Items
                    </h5>
                  </div>
                  <span
                    style={{
                      fontSize: "0.7rem",
                      color: "#6c757d",
                      fontWeight: "600",
                    }}
                  >
                    {orderData.items.length}{" "}
                    {orderData.items.length === 1 ? "item" : "items"}
                  </span>
                </div>

                {/* Items List */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    flex: 1,
                    // height: "10vh",
                    minHeight: "calc(100vh - 49vh)",

                    maxHeight: "calc(100vh - 49vh)",
                    overflowY: "auto",
                    overflowX: "hidden",
                  }}
                >
                  {orderData.items.map((it, idx) => (
                    <div
                      key={it.uid || it.id || idx}
                      style={{
                        padding: "10px",
                        backgroundColor: "#f8f9fa",
                        borderRadius: "8px",
                        border: "1px solid #e9ecef",
                      }}
                    >
                      {/* Item Header */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "flex-start",
                          gap: "10px",
                          marginBottom: "6px",
                        }}
                      >
                        {/* Left: Name & Price */}
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div
                            style={{
                              fontWeight: "600",
                              fontSize: "0.8rem",
                              marginBottom: "3px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "-webkit-box",
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: "vertical",
                              color: "#212529",
                            }}
                          >
                            {it.name}
                          </div>
                          <div style={{ fontSize: "0.7rem", color: "#6c757d" }}>
                            Rs. <NumberWithCommas number={it.productPrice} />{" "}
                            each
                          </div>
                        </div>

                        {/* Right: Qty & Total */}
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-end",
                            gap: "3px",
                            flexShrink: 0,
                          }}
                        >
                          <div
                            style={{
                              fontSize: "0.7rem",
                              color: "#495057",
                              backgroundColor: "white",
                              padding: "2px 6px",
                              borderRadius: "4px",
                              border: "1px solid #dee2e6",
                              fontWeight: "600",
                            }}
                          >
                            Qty: {it.qty}
                          </div>
                          <div
                            style={{
                              fontWeight: "700",
                              fontSize: "0.8rem",
                              color: "#f85606",
                            }}
                          >
                            Rs.{" "}
                            <NumberWithCommas
                              number={
                                it.total || (it.totalPrice || 0) * (it.qty || 0)
                              }
                            />
                          </div>
                        </div>
                      </div>

                      {/* Item Details */}
                      {((it.addons || []).length > 0 ||
                        it.note ||
                        (it.attributes && it.attributes.length > 0)) && (
                        <div
                          style={{
                            padding: "8px",
                            backgroundColor: "white",
                            border: "1px solid #e9ecef",
                            borderRadius: "6px",
                            marginTop: "6px",
                          }}
                        >
                          {/* Addons */}
                          {(it.addons || []).length > 0 && (
                            <div className="mb-2">
                              <div
                                style={{
                                  fontSize: "0.7rem",
                                  fontWeight: "700",
                                  color: "#495057",
                                  marginBottom: "4px",
                                  textTransform: "uppercase",
                                  letterSpacing: "0.5px",
                                }}
                              >
                                Add-ons
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "3px",
                                }}
                              >
                                {(it.addons || []).map((a, i) => (
                                  <div
                                    key={i}
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      fontSize: "0.75rem",
                                      color: "#6c757d",
                                      paddingLeft: "6px",
                                    }}
                                  >
                                    <span>• {a.name || a.productName}</span>
                                    {a.price && (
                                      <span
                                        style={{
                                          fontWeight: "600",
                                          color: "#495057",
                                        }}
                                      >
                                        Rs. {a.price}
                                      </span>
                                    )}
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}

                          {/* Attributes */}
                          {it.attributes && it.attributes.length > 0 && (
                            <div className="mb-2">
                              <div
                                style={{
                                  fontSize: "0.7rem",
                                  fontWeight: "700",
                                  color: "#495057",
                                  marginBottom: "4px",
                                  textTransform: "uppercase",
                                  letterSpacing: "0.5px",
                                }}
                              >
                                Options
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: "4px",
                                }}
                              >
                                {it.attributes.map((a, i) => (
                                  <span
                                    key={i}
                                    style={{
                                      fontSize: "0.7rem",
                                      backgroundColor: "#e9ecef",
                                      padding: "3px 6px",
                                      borderRadius: "4px",
                                      color: "#495057",
                                      fontWeight: "600",
                                    }}
                                  >
                                    {a.title}: {a.value}
                                  </span>
                                ))}
                              </div>
                            </div>
                          )}

                          {/* Notes */}
                          {it.note && (
                            <div>
                              <div
                                style={{
                                  fontSize: "0.7rem",
                                  fontWeight: "700",
                                  color: "#495057",
                                  marginBottom: "4px",
                                  textTransform: "uppercase",
                                  letterSpacing: "0.5px",
                                }}
                              >
                                Special Instructions
                              </div>
                              <div
                                style={{
                                  fontSize: "0.75rem",
                                  color: "#6c757d",
                                  fontStyle: "italic",
                                  paddingLeft: "6px",
                                }}
                              >
                                "{it.note}"
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </CardBody>
            </Card>

            {/* Total Amount & Checkout Button */}
            <Card className="">
              <CardBody>
                <div className="d-flex justify-content-between align-items-center ">
                  <span
                    style={{
                      fontSize: "0.8rem",
                      fontWeight: "600",
                      color: "#495057",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                    }}
                  >
                    Total Amount
                  </span>
                  <span
                    style={{
                      fontSize: "1rem",
                      fontWeight: "700",
                      color: "#f85606",
                    }}
                  >
                    Rs. <NumberWithCommas number={orderData.total} />
                  </span>
                </div>

                <Button
                  style={{
                    width: "100%",
                    padding: "12px",
                    fontWeight: "600",
                    fontSize: "0.8rem",
                    borderRadius: "8px",
                    backgroundColor: "#f85606",
                    border: "none",
                    boxShadow: "0 2px 6px rgba(248, 86, 6, 0.25)",
                    cursor: isLoading ? "not-allowed" : "pointer",
                    opacity: isLoading ? 0.7 : 1,
                  }}
                  onClick={() => {
                    playBeep();
                    handleProceedToCheckout();
                  }}
                  disabled={isLoading}
                >
                  {isLoading ? "Processing..." : "Proceed to Checkout →"}
                </Button>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </PublicOrderingLayout>

      {/* Testing Modal - Accessible via Ctrl+Shift+P */}
      <Modal
        isOpen={showPayloadPreview}
        toggle={() => setShowPayloadPreview(false)}
        centered
        size="lg"
      >
        <ModalHeader toggle={() => setShowPayloadPreview(false)}>
          📋 Order Payload Preview (Testing Mode)
        </ModalHeader>
        <ModalBody>
          <div style={{ marginBottom: "15px" }}>
            <p style={{ fontWeight: "600", marginBottom: "10px" }}>
              This is the exact data that will be sent to the API:
            </p>
            <p style={{ fontSize: "0.75rem", color: "#6c757d", fontStyle: "italic" }}>
              💡 Tip: Press <kbd>Ctrl+Shift+P</kbd> anytime to open this testing modal
            </p>
          </div>

          {/* Display Payload as JSON */}
          <div
            style={{
              backgroundColor: "#f5f5f5",
              padding: "15px",
              borderRadius: "8px",
              border: "1px solid #ddd",
              overflow: "auto",
              maxHeight: "400px",
              fontFamily: "monospace",
              fontSize: "0.8rem",
              color: "#333",
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
            }}
          >
            {payloadData
              ? JSON.stringify(payloadData, null, 2)
              : "No payload data"}
          </div>

          <div
            style={{
              marginTop: "15px",
              padding: "10px",
              backgroundColor: "#e3f2fd",
              borderRadius: "6px",
            }}
          >
            <p style={{ fontSize: "0.85rem", color: "#1565c0", margin: "0" }}>
              ℹ️ <strong>Copy this data for testing:</strong> Open the browser
              console to see the full payload logged.
            </p>
          </div>

          {/* Print Status Message */}
          {printMessage && (
            <div
              style={{
                marginTop: "15px",
                padding: "12px",
                backgroundColor: printMessage.includes("✅")
                  ? "#d4edda"
                  : printMessage.includes("❌")
                  ? "#f8d7da"
                  : "#fff3cd",
                borderRadius: "6px",
                border: `1px solid ${
                  printMessage.includes("✅")
                    ? "#c3e6cb"
                    : printMessage.includes("❌")
                    ? "#f5c6cb"
                    : "#ffeaa7"
                }`,
                color: printMessage.includes("✅")
                  ? "#155724"
                  : printMessage.includes("❌")
                  ? "#721c24"
                  : "#856404",
                fontSize: "0.85rem",
              }}
            >
              {printMessage}
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={() => setShowPayloadPreview(false)}
          >
            Close
          </Button>
          <Button
            color="warning"
            onClick={handleManualPrint}
            disabled={isPrinting}
          >
            {isPrinting ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                  style={{ width: "14px", height: "14px" }}
                />
                Printing...
              </>
            ) : (
              "🖨️ Print Bill (Test)"
            )}
          </Button>
          <Button
            color="success"
            onClick={handleConfirmAndSubmit}
            disabled={isLoading}
          >
            {isLoading ? "Submitting..." : "✅ Confirm & Submit"}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default OrderSummary;
